import {
    ActivitiesHomePageMobileContextFieldsV1,
    ActivitiesHomePageMobileContextIdsV1,
    ActivitiesHomePageMobileContextManifestV1,
} from '@agoda/analytics-messages-definition-activities/manifest/activities-home-page-mobile';
import { WebAnalyticsBinder } from 'core/messaging/analytics/ActivitiesAppDataContext';

export const homePageMobileBinder: WebAnalyticsBinder = (webAnalytics) => {
    webAnalytics.pageContext<ActivitiesHomePageMobileContextIdsV1, ActivitiesHomePageMobileContextFieldsV1>(ActivitiesHomePageMobileContextManifestV1.ids, {});
};
